import React from 'react'
import { withTranslation } from 'react-i18next'

import UserActivityDonePanelActions from './UserActivityDonePanelActions'
import Button from 'app/components/ButtonDefault'
import './styles.scss'

const bc = 'user-activity-done-panel'
const userActivityDonePanel = ({ t, handleSubmit, pending, activityId, isFavorite, isYesterday }) => (
  <form className={bc} onSubmit={handleSubmit}>
    <div className={`${bc}__text`}>
      <div className={`${bc}__title`}>{t('Great Job!')}</div>
      <div className={`${bc}__description`}>{t('You’re one step closer to forming a habit!')}</div>
    </div>
    <UserActivityDonePanelActions activityId={activityId} isFavorite={isFavorite} isYesterday={isYesterday} />
    <Button type="submit" disabled={pending} primary>
      {t('Done')}
    </Button>
  </form>
)

export default withTranslation('user')(userActivityDonePanel)
